import React from 'react'
import { Updater, async, fromJSX, onlyIf, Widget } from 'widgets-for-react'
import { parsePhoneNumber } from '../../../../../utils/phoneNumber'
import { PhoneNumbersBlock } from '../../blocksState'
import { PhoneNumbersBlockLayout } from './phoneNumbersBlockLayout'
import { PhoneNumbersBlockState } from './phoneNumbersBlockState'

export const phoneNumbersBlockWidget = (block: PhoneNumbersBlock): Widget<Updater<PhoneNumbersBlockState>> =>
  async<string[]>(block.phoneNumbersBlockState, phoneNumbers =>
    onlyIf(
      phoneNumbers.length === block.descriptions.length,
      fromJSX(() => (
        <PhoneNumbersBlockLayout
          index={block.index}
          inview={block.inview}
          size={block.size}
          contactItems={phoneNumbers.map((phoneNumber, i) => ({
            telephone: parsePhoneNumber(phoneNumber),
            description: block.descriptions[i],
          }))}
        />
      ))
    )
  )
